import Vue from "vue";
import Vuex from "vuex";
import actions from "./actions.js";

Vue.use(Vuex);

const store = new Vuex.Store({
  strict: process.env.NODE_ENV !== "production",

  state: {
    portfolio: {
      cliente: {}
    },
    urlAffinity: "",
    seleccion: {},
    displayBiggerThanPhone: false,
    registroInfo: null,
    telefonoAtencion: "91 594 88 00",
    telefonoAtencionGratuito: "900 108 860",
    nuevoTelefono: "",
    nuevoEmail: "",
    polizasSel: [],
    
  },

  mutations: {
    SET_PORTFOLIO(state, portfolio) {
      state.portfolio = portfolio;
    },

    SET_URLAFFINITY(state, url) {
      state.urlAffinity = url;
    },

    SET_SELECCION(state, sel) {
      if (sel === null) sel = {};
      state.seleccion = sel;
    },

    SET_DISPLAY_BIGGER_THAN_PHONE(state, val) {
      state.displayBiggerThanPhone = val;
    },

    SET_REGISTRO_INFO(state, registroInfo) {
      state.registroInfo = registroInfo;
    },

    SET_NUEVO_TELEFONO(state, nuevoTelefono) {
      state.nuevoTelefono = nuevoTelefono;
    },

    SET_NUEVO_EMAIL(state, nuevoEmail) {
      state.nuevoEmail = nuevoEmail;
    },

    SET_POLIZAS_SEL(state, polizasSel) {
      state.polizasSel = polizasSel;
    },

    
  },
  actions: actions
});

export default store;
